import api from 'api';
import { WEB_API_ROUTES } from 'api/api-routes';
import { apiWrapper } from '../../api/apiWrapper';
import { createThunk } from '../../utils/store-utils';

export const thunks = {
  getProfile: createThunk('profile/getProfile', () =>
    apiWrapper.get(WEB_API_ROUTES.profile.info)
  ),

  changeProfileFirstLogin: createThunk('profile/changeProfileFirstLogin', () =>
    api.put(WEB_API_ROUTES.profile.changeFirstLogin)
  ),

  getEvaluation: createThunk('profile/getEvaluation', (dancerId) =>
    api.get(WEB_API_ROUTES.profile.evaluation.replace('{dancerId}', dancerId))
  ),

  getRating: createThunk('profile/getRating', (dancerId) =>
    api.get(WEB_API_ROUTES.profile.rating.replace('{dancerId}', dancerId))
  ),

  getDancersList: createThunk('profile/getDancersList', () =>
    apiWrapper.get(WEB_API_ROUTES.profile.dancers)
  ),
};
